module.exports = __webpack_public_path__ + "media/images/icons/download-bold-e7fcaa13a2ffefe00627a72f8188645e.svg";